import React from 'react';

import isEmpty from 'lodash/isEmpty';

import { useCurrencyFormat } from '@gogame/intl-ts';

import { ActivityTypeBudgetBox, ActivityTypeBudgetText } from './components';

const BudgetValues = ({
  type,
  budget,
  budgetAllocated,
  budgetAllocatedError,
  renderIndicator,
}) => {
  const currencyFormatter = useCurrencyFormat();

  return (
    <ActivityTypeBudgetBox align={'center'} gutter={4}>
      {renderIndicator({
        activityType: type,
        budget,
        budgetAllocated,
      })}
      <ActivityTypeBudgetText error={Number(!isEmpty(budgetAllocatedError))}>
        {currencyFormatter(budgetAllocated)}
      </ActivityTypeBudgetText>
      <ActivityTypeBudgetText>/</ActivityTypeBudgetText>
      <ActivityTypeBudgetText>
        {currencyFormatter(budget)}
      </ActivityTypeBudgetText>
    </ActivityTypeBudgetBox>
  );
};

export default BudgetValues;
